import React, { useContext } from 'react';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import { WindowSizeContext } from '/src/App';

import marketDataKeys from '/src/services/ProcessingHousingMkt/MarketDataKeys.json';

import './style.css';

const WhatSignalsWeLookFor = ({ title }) => {
    const { deviceType } = useContext(WindowSizeContext);
    const introSentence = "At its core, we are trying to answer two key questions about climate and its role in this market. So when we assess market performance, we do it through the lens of how we’re seeing climate impact this area. "

    const profileSignals = marketDataKeys.filter(key => key.type === 'profile');
    const performanceSignals = marketDataKeys.filter(key => key.type === 'performance');

    const profileDescription = "Is climate changing how the market <span class='ltv-market-signals-signal-type-description-bold'>looks</span>?"
    const performanceDescription = "Is climate changing how the market <span class='ltv-market-signals-signal-type-description-bold'>performs</span>?"

    const marketSignalTypes = [
        {
            type: 'profile',
            description: profileDescription,
            signals: profileSignals
        },
        {
            type: 'performance',
            description: performanceDescription,
            signals: performanceSignals
        }
    ]

    return (
        <div className="ltv-market-signals-section-container">
            <h2 className="ltv-attractiveness-title">{title}</h2>
            <div className={`ltv-market-signals-signal-types-container ${deviceType}`}>
                {marketSignalTypes.map((signalType) => (
                    <div className="ltv-market-signals-signal-type-container">
                        <div className="ltv-market-signals-section-intro-sentence-container">
                            <span className="ltv-market-signals-signal-type-description text-align-center" dangerouslySetInnerHTML={{ __html: signalType.description }} />
                        </div>
                        <div className="ltv-market-signals-signal-type-signals-container">
                            {signalType.signals.map((signal) => (
                                <div className="ltv-market-signals-signal-type-signal-container">
                                    <span className="ltv-market-signals-signal-type-signal-title text-align-center">{signal.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <p className="ltv-market-signals-section-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: introSentence }} />
        </div>
    );
};

export default WhatSignalsWeLookFor;